export default __webpack_public_path__ + "static/media/datafarming-collection-notice.def6b93b.pdf";